import { faJava, faFlutter, faNodeJs, faReact } from "@fortawesome/free-brands-svg-icons";

export const stackItems = [
    { icon: faJava },
    { icon: faFlutter },
    { icon: faNodeJs },
    { icon: faReact },
];